import useGlobalStore from '@/store/useGlobalStore'
import { useLocation, useNavigate } from 'react-router-dom'
import { getEnterpriseInfo, getEnterpriseProduct } from '@/api'
import { getStorage, setStorage, sleep } from '@/utils/tools'
import { message } from 'antd'
import useCloudStore from '@/pages/cloudProject/store'
import { isPersonal } from '@/utils/help'
import { dataCheck } from '@/api/common'
import { useAuth } from './useAuth'
import { DefaultNavPath } from '@/config'
import useNav from '@/hooks/useNav'

export function useFetch() {
  const navigate = useNavigate()
  const { getAuthPathByCodes } = useAuth()
  const { navigateToDefaultRoute } = useNav()
  const { resetStore: resetCloudStore } = useCloudStore()
  const setGlobalState = useGlobalStore.setState
  const { systemKey, setAuthorized, setGlobalInfo, setAuthCodes, menuKeysMap } =
    useGlobalStore(s => ({
      systemKey: s.systemKey,
      setAuthorized: s.setAuthorized,
      setGlobalInfo: s.setGlobalInfo,
      setAuthCodes: s.setAuthCodes,
      resetGlobalStore: s.resetGlobalStore,
      menuKeysMap: s.menuKeysMap
    }))

  // 登录或者刷新时选择企业
  const selectEnterprise = async (epid: any, options?, callback?) => {
    const { isRefresh } = options || {}
    let enterpriseInfo = null
    let newTenantId = null
    try {
      let enterpriseRes = null
      enterpriseRes = await getEnterpriseInfo({
        epid,
        token: getStorage('token') || '',
      })
      if (enterpriseRes) {
        enterpriseInfo = enterpriseRes.enterpriseInfo
        newTenantId = enterpriseRes.tenantId
        if (enterpriseInfo) {
          // 获取企业的时候检查数据
          dataCheck({ "objectType": 0 })
        }
      } else {
        message.warning(
          `你的账号在${getStorage('enterpriseName')}的授权已失效。已为你切换到默认用户空间！` ||
          enterpriseRes.message,
        )
        await sleep(1000)
        enterpriseRes = await getEnterpriseInfo({
          epid: null,
          token: getStorage('token') || '',
        })

        if (enterpriseRes) {
          enterpriseInfo = enterpriseRes.enterpriseInfo
          newTenantId = enterpriseRes.tenantId
        }
      }

      const productRes = await getEnterpriseProduct()
      setGlobalInfo({
        currentEnterprise: enterpriseInfo,
        tenantId: newTenantId,
        productInfo: productRes,
      })
      setStorage('tenantId', newTenantId)
      setStorage('epid', enterpriseInfo?.epid)
      setStorage('enterpriseName', enterpriseInfo?.nameCn)
      const newAuthCodestr = enterpriseInfo?.authCodes || ''
      if (newAuthCodestr) {
        setAuthCodes(newAuthCodestr.split(';'))
      } else {
        setAuthCodes([])
      }
      const newAuthCodes = newAuthCodestr?.split(';') || []
      // 计算菜单权限
      // 所有有权限的config
      const authPaths = getAuthPathByCodes(newAuthCodes)
      // 根据权限配置计算菜单
      const newMenuKeysMap = Object.keys(menuKeysMap || {}).reduce((acc, key) => {
        const menus = (menuKeysMap as any)[key] || []
        const newMenus: any[] = []
        for (const item of menus as any[]) {
          if (item?.children) {
            const newChildren = (item.children || []).filter((child: any) => authPaths?.includes(child.path))
            newMenus.push({ ...item, children: newChildren })
          } else {
            if (authPaths?.includes(item.path)) {
              newMenus.push({ ...item })
            }
          }
        }
        // .filter((item: any) => {
        //   if (item?.path) {
        //     return authPaths?.includes(item.path)
        //   }
        //   return Array.isArray(item?.children) ? item.children.length > 0 : false
        // })
        (acc as any)[key] = newMenus;
        return acc
      }, {} as any)
      // console.log("newMenuKeysMap", newMenuKeysMap)
      setGlobalState({
        menuKeysMap: newMenuKeysMap
      })


      // 不是刷新，目前只有登录才会到这里
      if (!isRefresh) {
        // if (newTenantId?.startsWith('E')) {
        //   navigate(DefaultNavPath)
        // } else {
        //   navigate(DefaultNavPath)
        // }
        navigateToDefaultRoute()
      }

      // TODO: 刷新uselocation 拿到还是旧的路由，导致权限出现异常页面，原因不明
      await sleep(200)
      setAuthorized(true)

    } catch (error) {
      console.log(error)
    }
  }

  // 下拉选择企业
  const changeEnterprise = async (epid: any, callback?) => {
    try {
      const enterpriseRes = await getEnterpriseInfo({
        epid,
        token: getStorage('token') || '',
      })
      // 获取企业的时候检查数据
      // dataCheck({ "objectType": 0 })
      if (enterpriseRes) {
        const enterpriseInfo = enterpriseRes.enterpriseInfo
        const newTenantId = enterpriseRes.tenantId
        setStorage('tenantId', newTenantId)
        setStorage('epid', enterpriseInfo?.epid)
        setStorage('enterpriseName', enterpriseInfo?.nameCn)
        // navigate(DefaultNavPath)
        navigateToDefaultRoute()

        window.location.reload(); // 刷新页面，清空store
      }
    } catch (error) {
      console.log(error)
    }
  }

  return { selectEnterprise, changeEnterprise }
}
